import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit, OnDestroy {
  images = [
    { desktop: 'assets/img/1.jpg', mob: 'assets/img/mob1.jpg' },
    { desktop: 'assets/img/2.jpg', mob: 'assets/img/mob2.jpg' },
    { desktop: 'assets/img/3.jpg', mob: 'assets/img/mob3.jpg' },
    { desktop: 'assets/img/4.jpg', mob: 'assets/img/mob4.jpg' }
  ];


  currentIndex = 0;
  interval: any;
  slideInterval = 6000; // 4 segundos

  ngOnInit(): void {
    this.startAutoSlide();
  }

  startAutoSlide() {
    this.interval = setInterval(() => this.nextSlide(), this.slideInterval);
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
  }

  prevSlide() {
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
  }

  ngOnDestroy(): void {
    if (this.interval) clearInterval(this.interval);
  }
}
